import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"onboarding onboarding--loading u-cover\">\n  <div class=\"logo-animation\"></div>\n</div>")